import '../scss/sell-my-bag.scss';
import { $Q } from '../utils/query-selector';
import { toggleDataActive } from '../utils/toggle-dataset';

toggleDataActive(
  '.open-popup-link',
  '#js-smb-popup',
  {
    closeSelector: '#close-popup-link',
    overlay: true,
  },
);

/* It avoids scrolling to top */
$Q('.open-popup-link') && $Q('.open-popup-link').addEventListener('click', (event) => {
  event.preventDefault();
})

/**
 * Intersection Observer: Add preferred countries to phone input on sell my bag form
 */

function addPreferredLangsToPhoneInput() {
  window.intlTelInput($Q("#sell-my-bag .form__textfield-notlabel.coutry-custom input"),{
    preferredCountries:['FR','GB','DE','IT']
  })
}

const options = {
  root: null, 
  rootMargin: "0px",
  threshold: 0.5,
};

const sellMyBagTelInput = document.querySelector("#sell-my-bag .form__textfield-notlabel.coutry-custom input");

function intersectionCallback(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      addPreferredLangsToPhoneInput();
      observer.disconnect();
    }
  });
}

const observer = new IntersectionObserver(intersectionCallback, options);

observer.observe(sellMyBagTelInput);
